import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

import { Loader2 } from "lucide-react";

export const APP_BOOT_SLOW_AFTER_MS = 15_000;

interface AppBootScreenProps {
  message?: string;
  slowMessage?: string;
  slowAfterMs?: number;
  onRetry?: () => void;
}

export function AppBootScreen({
  message = "Loading…",
  slowMessage = "This is taking longer than expected. Check your connection and try again.",
  slowAfterMs = APP_BOOT_SLOW_AFTER_MS,
  onRetry,
}: AppBootScreenProps) {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsSlow(true), slowAfterMs);
    return () => window.clearTimeout(timer);
  }, [slowAfterMs]);

  const handleRetry = (): void => {
    if (onRetry) {
      onRetry();
      return;
    }
    window.location.reload();
  };

  return (
    <div
      className="flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-background px-4"
      role="status"
      aria-live="polite"
    >
      {isSlow ? null : (
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      )}
      <p className="text-center text-sm text-muted-foreground">{isSlow ? slowMessage : message}</p>
      {isSlow ? (
        <Button type="button" onClick={handleRetry}>
          Reload
        </Button>
      ) : null}
    </div>
  );
}
